import React, { useEffect, useState } from 'react';
export function StickyMobileCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-0 left-0 right-0 z-50 bg-[#0f0f0f]/95 backdrop-blur-md border-t border-[#2a2a2a] md:hidden animate-slide-up" data-id="element-130">
      {/* Urgency bar */}
      <div className="flex items-center justify-center gap-2 py-1.5 bg-red-600/10 border-b border-red-600/20" data-id="element-131">
        <span className="w-1.5 h-1.5 rounded-full bg-red-500 animate-pulse" data-id="element-132"></span>
        <p className="text-xs text-red-400 font-semibold uppercase tracking-wider" data-id="element-133">
          Está ahora y solo por tiempo limitado
        </p>
        <span className="w-1.5 h-1.5 rounded-full bg-red-500 animate-pulse" data-id="element-134"></span>
      </div>

      <div className="p-4" data-id="element-135">
        <button onClick={() => document.getElementById('price-box')?.scrollIntoView({
        behavior: 'smooth'
      })} className="w-full bg-[#C9A84C] text-black font-bold py-3.5 px-4 rounded-lg shadow-lg active:scale-[0.98] transition-transform flex items-center justify-center gap-3" data-id="element-136">
          <span className="text-base" data-id="element-137">Comprar ahora</span>
          <span className="flex items-center gap-1.5" data-id="element-138">
            <span className="line-through text-black/50 text-sm font-medium" data-id="element-139">
              $27
            </span>
            <span className="bg-black text-[#C9A84C] font-bold text-base px-2 py-0.5 rounded" data-id="element-140">
              $6.39
            </span>
          </span>
        </button>
      </div>
    </div>;
}